import { render, staticRenderFns } from "./L01Class.vue?vue&type=template&id=06cf8753&"
import script from "./L01Class.vue?vue&type=script&lang=js&"
export * from "./L01Class.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports